import { css } from 'styled-components';

import { BadgePosition } from './AvatarWithBadge.types';

export function getBadgePositionCss(position: BadgePosition) {
  switch (position) {
    case 'bottom-right':
      return css`
        bottom: 15%;
        right: 15%;
        transform: translate(50%, 50%);
      `;

    default: {
      if (typeof position !== 'string') {
        return css`
          top: ${position.top};
          bottom: ${position.bottom};
          left: ${position.left};
          right: ${position.right};
          transform: ${position.transform};
        `;
      }

      return css``;
    }
  }
}
